import { mapState } from 'vuex'
import { globalConst as native, modulesName, modalTitle } from 'lib/const'
import { isEmptyObject, hexToStr, strToHex, numToHex } from 'lib/utils'
import { getMediaUrl } from 'lib/common'
import Vue from 'vue'
import { PACKAGE_TYPE_AI, PACKAGE_TYPE_MADE } from 'lib/packageFile'
import { auto } from 'async-es'

const installPackageMixin = {
  data () {
    return {}
  },
  created () {

  },
  methods: {
    installPack (installPackage, index) {
      let contentText = ''
      const self = this
      if (installPackage.packageType === PACKAGE_TYPE_MADE) {
        contentText = `<li>
                          <div class="item-content item-input">
                            <div class="item-inner">
                              <div class="item-title item-label"  style="text-align: left">内容贴</div>
                              <div class="item-input-wrap">
                                <input type="number" class='content' name="content" placeholder="请输入内容贴">
                              </div>
                            </div>
                          </div>
                         </li>`
      }
      const text = `<form class="list" id="my-form">
                          <ul>
                            <li>
                              <div class="item-content item-input">
                                <div class="item-inner">
                                  <div class="item-title item-label" style="text-align: left">封面贴</div>
                                  <div class="item-input-wrap">
                                    <input type="number" class='oid' name="title" placeholder="请输入封面贴">
                                  </div>
                                </div>
                              </div>
                            </li>
                            ${contentText}
                          </ul>
                        </form>`
      this.$f7.dialog.confirm(text, '安装点读包', () => {
        let oidEl = document.querySelector('#my-form .oid')
        let contentEl = document.querySelector('#my-form .content')
        let content = ''
        let oid = ''
        if (oidEl) {
          oid = oidEl.value
        }
        if (contentEl) {
          content = contentEl.value
        }
        if (!oid) {
          this.$f7.dialog.alert('封面贴必填', modalTitle)
          return
        }
        if (installPackage.packageType === PACKAGE_TYPE_MADE && !content) {
          this.$f7.dialog.alert('内容贴必填', modalTitle)
          return
        }

        const {chkcode, imbcode} = this
        const {guid} = installPackage
        const {dispatch} = this.$store
        dispatch({
          type: native.installPack,
          baseUrl: webServiceUrl,
          function: 'cryptdata',
          chkcode,
          imbcode,
          guid
        }).then(({data}) => {
          let results = data.rs
          results = results.map((rs) => rs.toString(16).padStart(2, 0))
          auto({
            writeSecret: function (cb) {
              const a = dispatch({
                type: native.writeBlock,
                baseUrl: self.downLoaderServerUrl,
                filename: installPackage.path,
                org_offset: installPackage.secretStartIdx,
                len: installPackage.secretStartLen,
                data: results.shift(),
                flag: 'end'
              })
              const b = dispatch({
                type: native.writeBlock,
                baseUrl: self.downLoaderServerUrl,
                filename: installPackage.path,
                org_offset: installPackage.secretEndIdx,
                len: installPackage.secretEndLen,
                data: results.join(''),
                flag: 'end'
              })
              Promise.all([a, b]).then(() => {
                cb(null)
              }).catch((error) => {
                cb(error)
              })
            },
            writeSecret2: function (cb) {
              if (installPackage.isUNB) {
                return cb(null)
              }
              dispatch({
                type: native.installPack,
                baseUrl: webServiceUrl,
                function: 'cryptdab2',
                oid,
                otype: installPackage.packageType
              }).then(({data}) => {
                let results = data.buf
                results = results.map((rs) => rs.toString(16).padStart(2, 0))
                const a = dispatch({
                  type: native.writeBlock,
                  baseUrl: self.downLoaderServerUrl,
                  filename: installPackage.path,
                  org_offset: installPackage.secret2StartIdx,
                  len: installPackage.secret2StartLen,
                  data: results.shift(),
                  flag: 'end'
                })
                const b = dispatch({
                  type: native.writeBlock,
                  baseUrl: self.downLoaderServerUrl,
                  filename: installPackage.path,
                  org_offset: installPackage.secret2EndIdx,
                  len: installPackage.secret2EndLen,
                  data: results.join(''),
                  flag: 'end'
                })
                let results_oid = data.oid
                let oid_h = (results_oid % 256).toString(16).padStart(2, 0)
                let oid_l = (Math.floor(results_oid / 256)).toString(16).padStart(2, 0)
                const c = dispatch({
                  type: native.writeBlock,
                  baseUrl: self.downLoaderServerUrl,
                  filename: installPackage.path,
                  org_offset: installPackage.oidIdx,
                  len: installPackage.oidLen,
                  data: oid_h + oid_l,
                  flag: 'end'
                })
                Promise.all([a, b, c]).then(() => {
                  cb(null)
                }).catch((error) => {
                  cb(error)
                })
              })
            },
            setContent: function (cb) {
              if (installPackage.packageType !== PACKAGE_TYPE_MADE) {
                return cb(null)
              }
              if (!installPackage.isUNB) {
                dispatch({
                  type: native.writeBlock,
                  baseUrl: self.downLoaderServerUrl,
                  filename: installPackage.path,
                  org_offset: installPackage.contentIdx,
                  len: installPackage.contentLen,
                  data: numToHex(content),
                  flag: 'end'
                }).then(() => {
                  cb(null)
                }).catch((error) => {
                  cb(error)
                })
              } else {
                dispatch({
                  type: native.readBlock,
                  baseUrl: self.downLoaderServerUrl,
                  filename: installPackage.path,
                  org_offset: installPackage.xorIdx,
                  len: installPackage.xorLen
                }).then(({data}) => {
                  let hexContentArr = numToHex(parseInt(content, 10)).match(/\S{2}/g)
                  let hexXorArr = data.match(/\S{2}/g)
                  let [hstr, lstr] = hexContentArr
                  let [hXorStr, lXorStr] = hexXorArr
                  let h = (parseInt(hstr, 16) ^ parseInt(hXorStr, 16)).toString(16)
                  let l = (parseInt(lstr, 16) ^ parseInt(lXorStr, 16)).toString(16)
                  let hexContent = (h + '').padStart(2, 0) + (l + '').padStart(2, 0)
                  dispatch({
                    type: native.writeBlock,
                    baseUrl: self.downLoaderServerUrl,
                    filename: installPackage.path,
                    org_offset: installPackage.contentIdx,
                    len: installPackage.contentLen,
                    data: hexContent,
                    flag: 'end'
                  }).then(() => {
                    cb(null)
                  }).catch((error) => {
                    cb(error)
                  })
                  //  cb(null)
                })
              }

            },
            changeFileName: ['writeSecret', 'writeSecret2', 'setContent', function (funResults, cb) {
              let suffix = '.das'
              if (installPackage.packageType === PACKAGE_TYPE_MADE) {
                suffix = '.dar'
              }
              const changedname = oid.padLeft(3, 0) + suffix
              dispatch({
                type: native.rename,
                baseUrl: self.downLoaderServerUrl,
                filename: installPackage.path,
                changedname,
                flag: 'end'
              }).then(() => {
                try {
                  let dom = document.querySelectorAll('.tab-3 .media-item')[index]
                  self.$f7.swipeout.close(dom)
                  self.installListFile[index].fileName = changedname
                  self.installListFile[index].number = oid.padLeft(3, 0)
                  self.installListFile[index].path = installPackage.dir + '/' + changedname
                  self.installListFile[index].canBeInstall = false
                  const [pack] = self.installListFile.splice(index, 1)
                  self.listFile.push(pack)
                } catch (e) {
                  console.error(e)
                }
                cb(null)
              }).catch((error) => {
                cb(error)
              })
            }],
          }, (error, results) => {
            if (error) {
              self.$f7.dialog.alert('安装失败', modalTitle)
              return
            }
            self.$f7.dialog.alert('安装成功', modalTitle)
          })
        }).catch(() => {
          // this.pack.install(result)
        })
      })
    },
  },
  computed: {
    ...mapState({
      listFile: ({downLoader}) => downLoader.listFile,
      installListFile: ({downLoader}) => downLoader.installListFile,
      chkcode: ({downLoader}) => downLoader.chkcode,
      imbcode: ({downLoader}) => downLoader.imbcode,
      downLoaderServerUrl: ({downLoader}) => downLoader.downLoaderServerUrl
    })
  }
}
export default installPackageMixin
